import React from "react";
import { Breadcrumb } from "react-bootstrap";
import DayVisitorForm from "../components/DayVisitorForm";
import styled from "styled-components";

const Styles = styled.div`  
.list-decimal {
    list-style-type: decimal;
}

.mandatory-note {
    color: red;
}

.content-top-header {
    color: #a6192e;
}

.breadcrumb-bg { 
    background-color:#e9ecef;
}
 
`;

const DayVisitor = () => {

    return (
        <Styles>
            <div className="row breadcrumb-bg animate__animated animate__fadeIn">
                <div className="container">
                    <Breadcrumb>
                        <Breadcrumb.Item href="https://www.ttsh.com.sg/Pages/default.aspx"><small>Home</small></Breadcrumb.Item>
                        <Breadcrumb.Item href="/"><small>Visitor Facilitation</small></Breadcrumb.Item>
                        <Breadcrumb.Item active><small>Accompanying Day Procedure Patient</small></Breadcrumb.Item>
                    </Breadcrumb>
                </div>
            </div>

            <div className="container">
                <br />
                <div className="content-top">
                    <h3 className="content-top-header animate__animated animate__fadeInLeft animate__delay-500ms">DAY PROCEDURE / DAY SURGERY VISTOR REGISTRATION</h3>
                    <p className="animate__animated animate__fadeInUp animate__delay-600ms">
                        This registration is meant to facilitate visitors accompanying patients for their Day Procedure/Day Surgery as they are required to access the gantries at the lift lobbies to reach the upper levels of Blocks 4, 5 and 6/7. Gantry access is valid on the date of the patient’s appointment. Visitors are to strictly abide by SGH’s visiting policy of one (1) visitor per patient.
                </p>
                </div>

                <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                <div className="content-instructions animate__animated animate__fadeInUp animate__delay-700ms">
                    <h5>INSTRUCTIONS FOR REGISTRATION</h5>

                    <ol className="list-decimal">
                        <li>Registration is non-transferrable and valid on the patient’s Day Procedure/Day Surgery appointment day. Visitors who wish to accompany the patient on subsequent dates will have to re-register themselves again.</li>
                        <li>Registration is applicable for Day Procedures/ Day Surgery at the following centres:</li>
                        <ul>
                            <li>Ambulatory Surgical Centre e.g colorectal surgery, general surgery</li>
                            <li>Inpatient and Lung Endoscopy Centre e.g colonoscopy, bronchoscopy, gastroscopy</li>
                            <li>Haematology Centre e.g bone-marrow procedure and treatment</li>
                            <li>Pain Management Centre e.g epidural lysis of adhesions, epidural steroid injection, nerve blocks and trigger point injection</li>
                        </ul>
                        <li>Visitors accompanying outpatients for doctor’s consultation or Acupuncture Services should complete the “Outpatient Visitor Registration” page. If the centre or clinic is not listed above, please register at the Visitor Registration Counters at Level 1 Lift Lobbies.</li>
                        <li>Only one (1) visitor may register for the same patient.</li>
                        <li>Registration does not give visitors unlimited access to the ward levels.</li>
                        <li>Registration is only applicable to Singaporeans, permanent residents and foreigners holding work permits or employment passes. Other foreign visitors are required to register at the Visitor Registration Counters at Level 1 Lift Lobbies.</li>
                        <li>Children below the age of 12 are not permitted to visit clinical areas.</li>
                        <li>Visitors are required to fill in:</li>
                        <ul>
                            <li>Visitor's name and NRIC / FIN number.</li>
                            <li>Patient's full name (as in identity card), NRIC/FIN number and date of appointment.</li>
                        </ul>
                        <li>Visitors may call our general enquiries line at 0000 0000 for assistance</li>
                    </ol>
                </div>

                <hr className="animate__animated animate__bounceIn animate__delay-1s" />

                <div className="content-form animate__animated animate__fadeInUp animate__delay-800ms">
                    <h5>REGISTRATION FORM</h5>
                    <small className="mandatory-note">* Mandatory </small>

                    {/* Outpatient Visitor form */}
                    <DayVisitorForm />

                </div>
            </div>
        </Styles >
    );
};

export default DayVisitor;
 